import { InMemoryDbService } from 'angular-in-memory-web-api';

export class FakeDataService implements InMemoryDbService {

  createDb() {
    let prescriptions = [
      { id: 1, datePrescription: '12-02-2018', agent: 'Gabriel Mané', nbAnalyse: 2 },
      { id: 2, date: '23-05-2016', agent: 'Abdallah Macina', nbAnalyse: 1 },
      { id: 3, date: '28-12-2015', agent: 'Gabriel Mané', nbAnalyse: 3 },
    ];
    return { prescriptions: prescriptions };
  }

}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/in-memory-api/fake-data.service.ts